import { sourceOfWealthTypes, sourceOfWealthFrequencies } from "@goodfill/domain-customer-application-types";
import { zRequiredBoolean } from "@goodfill/domain-properties-zod-validators";
import { DefaultValues } from "react-hook-form";
import z from "zod";

export const formSourceOfWealthSchema = z
  .object({
    // Do not use just `type` there is collision with internal property in react-hook-form
    wealthType: z.enum(sourceOfWealthTypes),
    frequency: z.enum(sourceOfWealthFrequencies),
    isUsedForFunds: zRequiredBoolean(),
    description: z.string(), // intentionally not required, required only if (type === "other")
  })
  .refine((val) => val.wealthType !== "other" || val.description.trim().length > 0, {
    path: ["description"],
    message: "required",
  });

export type FormSourceOfWealth = z.infer<typeof formSourceOfWealthSchema>;

export const defaultSourceOfWealth: DefaultValues<FormSourceOfWealth> = {
  description: "",
};
